import React from 'react';
import BaseModal, {
	BaseModalProps,
} from '../../../Modules/Base/Components/BaseModal/BaseModal';
import PatientProfileDataCompareTable from './PatientProfileDataCompareTable';

interface Props extends BaseModalProps {
	patientId: string;
}

const PatientProfileDataCompareModal = ({
	patientId,
	...modalProps
}: Props) => {
	return (
		<BaseModal
			{...modalProps}
			title='patientTreatment.profile.compareData.title'>
			<PatientProfileDataCompareTable patientId={patientId} />
		</BaseModal>
	);
};

export default PatientProfileDataCompareModal;
